import { render, staticRenderFns } from "./editTheme.vue?vue&type=template&id=30d88bb6&lang=pug"
import script from "./editTheme.vue?vue&type=script&lang=js"
export * from "./editTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports